/**
 * CARD
 */

import { faCog } from "@fortawesome/free-solid-svg-icons"
import ListButton from "./list-button"
import PageLoader from "./page-loader"
import { STATUS_LOADED } from "@/redux/_status.types"
import HelpHint from "@/components/help-hint"
import { useCardBreathe } from "./skeleton"

interface OwnProps {
  className?: string
  style?: React.CSSProperties
  children?: any
  exportName?: string
  helpSection?: string //Anchor of the section of the guide for this card : a hint appears when the card is hovered
  helpClassName?: string //Position of the hint (default : top right)
  isFullWidth?: boolean
  isWithoutPadding?: boolean //Force no padding
  isOverflowHidden?: boolean //Overflow inside the Card
  isWithMinHeight?: boolean
  isNotCardClass?: boolean
  isSelected?: boolean //Undefined: no selection styling
  onClick?: Function //On click
  onOption?: Function //Option button
  status?: string //Display loading in card
  title?: React.ReactNode //Title
  skeleton?: React.ReactNode //Remplace le spinner de chargement par ce skeleton si fourni
  //Pulse la card (timing randomisé) — opt-in explicite, jamais déclenché par `status` seul pour
  //ne pas faire pulser toutes les cards existantes de l'app (Card est utilisé ~60 fois avec un `status`)
  isBreathing?: boolean
  breatheVariant?: "scale" | "glow" //Défaut "scale" (léger zoom) ; "glow" pulse l'ombre portée sans bouger les bords
}

function Card(props: OwnProps) {
  const breatheStyle = useCardBreathe(props.breatheVariant)

  function click(e: React.MouseEvent) {
    if (props.onClick) {
      props.onClick(e)
    }
  }

  function clickOptions() {
    if (props.onOption) {
      props.onOption()
    }
  }

  return (
    <div
      className={
        (!props.isNotCardClass ? "card " : "") +
        (props.helpSection ? "group " : "") +
        (props.className ? props.className : "") +
        (props.exportName ? " card-exportable" : "") +
        (props.isSelected !== undefined ? " group cursor-pointer" : "")
      }
      id={props.exportName}
      onClick={click}
      style={{
        padding: !props.isWithoutPadding ? "20px 30px" : "",
        overflow: props.isOverflowHidden ? "auto" : "",
        minWidth: props.isFullWidth ? "100%" : props.status ? "190px" : "",
        minHeight: props.isWithMinHeight ? "200px" : "",
        ...props.style,
        ...(props.isBreathing ? breatheStyle : undefined)
      }}>
      {props.isSelected !== undefined && (
        // Barre en surimpression : la selection ne decale pas le contenu.
        <div
          className={`absolute inset-y-0 left-0 w-[8px] rounded-l-[12px] ${
            props.isSelected ? "bg-idt-primary-main" : "group-hover:bg-idt-primary-main/40"
          }`}
        />
      )}
      {props.helpSection && <HelpHint section={props.helpSection} className={props.helpClassName} />}

      {props.onOption && (
        <div className="card-options">
          <ListButton icon={faCog} onClick={clickOptions} />
        </div>
      )}

      {props.title && <div className="card-title flex">{props.title}</div>}

      <PageLoader
        status={props.status ? props.status : STATUS_LOADED}
        minHeight={props.status ? 120 : 1}
        skeleton={props.skeleton}>
        {props.children}
      </PageLoader>
    </div>
  )
}

export default Card
